import cn from 'classnames';
import { CheckIcon } from '#assets/ReactSvg.ts';
import styles from './FeatureList.module.css';

type Props = {
  features: string[];
};

/** Checkmarked feature bullets shared by the Free and Pro plan cards so the two stay visually in sync */
export function FeatureList({ features }: Props) {
  return (
    <ul className={styles.FeatureList}>
      {features.map((feature) => (
        <li key={feature} className={cn('p-md flex gap-8 align-center', styles.FeatureList_feature)}>
          <CheckIcon className={styles.FeatureList_featureCheck} fontSize="0.8em" />
          {feature}
        </li>
      ))}
    </ul>
  );
}
